<template>
  <div class="service-item">
    <img class="icon" :src="iconUrl" v-if="iconUrl" />
    <div class="meta">
      <div class="name">{{ name }}</div>
      <p class="desc mt-2" v-if="shortDescription">{{ shortDescription }}</p>
      <p class="mt-2" v-if="mainOption">Option หลัก: {{ mainOption }}</p>
      <p v-if="extraOption">Option เสริม: {{ extraOption }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "iconUrl",
    "name",
    "description",
    "shortDescription",
    "mainOption",
    "extraOption"
  ]
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";

.service-item {
  background-color: rgba(81, 117, 225, 0.1);
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  padding: 12px 24px;

  > .icon {
    margin-top: 4px;
    border-radius: 8px;
    width: 64px;
    height: 64px;
  }

  > .icon + .meta {
    padding-left: 16px;
  }

  > .meta {
    display: block;
    flex-grow: 1;
    align-self: center;
  }
}

.meta {
  width: 100%;

  > .name {
    font-size: 18px;
    font-weight: bold;
  }

  > .desc {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 14px;
  color: #606060;
}

@media (max-width: ($m-size - 1)) {
  .service-item {
    > .icon {
      width: 48px;
      height: 48px;
    }

    > .icon + .meta {
      padding-left: 12px;
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .service-item {
    display: flex;
    flex-direction: column;
    padding: 8px 16px;

    > .icon {
      width: 48px;
      height: 48px;
    }

    > .icon + .meta {
      padding-left: 4px;
      padding-top: 8px;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .service-item {
    padding: 8px 16px;

    > .icon {
      width: 50px;
      height: 50px;
    }

    > .icon + .meta {
      padding-left: 12px;
    }
  }

  .meta {
    > .name {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/ServiceItem.vue